import { Button } from "antd";
import { useState, useEffect } from "react";

export default function UnlockAudioModal() {
  const [showModal, setShowModal] = useState(true);



  const unlockAudio = () => {
    const ctx = new (window.AudioContext || window.webkitAudioContext)();
    const buffer = ctx.createBuffer(1, 1, 22050);
    const source = ctx.createBufferSource();
    source.buffer = buffer;
    source.connect(ctx.destination);
    source.start(0);
    // console.log("Audio unlocked!");
    setShowModal(false); // Close the fake modal
  };

  return (
    <>
      {showModal && (
        <div className="fixed inset-0 bg-black/60 flex items-center justify-center z-50">
          <div className="bg-white rounded-xl p-6 w-80 text-center shadow-lg">
            <p className="text-lg font-bold mb-4 text-black">👋 Welcome back!</p>
            <p className="text-sm text-gray-600 mb-6">
              We’re just getting things ready for you. Tap continue to proceed.
            </p>
            <div className="flex gap-5">
              <Button
                onClick={unlockAudio}
                className="bg-green-600 text-white px-4 py-2 rounded-md flex items-center justify-center w-full text-center"
              >
                🚀 Continue
              </Button>
              <Button
                onClick={unlockAudio}
                className="bg-gray-300 text-gray-700 px-4 py-2 rounded-md flex items-center w-full justify-center"
              >
                Skip
              </Button>
            </div>
          </div>
        </div>
      )}
    </>
  );
}
